export default __webpack_public_path__ + "static/media/download.afa1e6e4.svg";